import { Box, Divider, Typography, Button, Stack } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";

import IllustrationBottomleft from "../../assets/Login/Login2.png";
import hospitalsServices from "../../services/hospitalsServices";
import { ILoggedUser, setLoggedUser } from "../../store/actions";
import TopLeftIlustration from "../../assets/Login/Login1.png";
import BackgroundRight from "../../assets/Login/Login3.png";
import ReachLogo from "../../assets/Logos/reach_logo.png";
import usersServices from "../../services/usersServices";
import useToken from "../../utils/useToken";
import {
	HOSPITALS_AVAILABLE,
	HOSPITALS_MAP,
	Position,
	POSITIONS_AVAILABLE,
} from "./LoginUtils";
import "./Login.scss";
import { useNavigate } from "react-router-dom";

export default function Login() {
	const dispatch: Dispatch<any> = useDispatch();

	const { setToken } = useToken();

	const { instance } = useMsal();

	const blank_user: ILoggedUser = {
		id: 0,
		initials: "",
		name: "",
		lastName: "",
		fullName: "",
		position: Position.COLAB,
		hospital: [],
		isAdmin: false,
	};

	dispatch(setLoggedUser(blank_user));

	// const navigate = useNavigate();
	// const dummyLoginIn = (): void => {
	// 	const userPosition: Position = Position.SUPERADMIN;
	// 	const userHospitals: string[] = HOSPITALS_AVAILABLE;

	// 	const getToken = async () => {
	// 		const res_token = await loginUser("erik.gonzalez@christuscei.mx");

	// 		setToken(res_token);
	// 	};

	// 	try {
	// 		getToken();

	// 		usersServices.getUserLogged().then((res) => {
	// 			const user: ILoggedUser = {
	// 				id: 5,
	// 				initials: "EG",
	// 				name: "Erik Josías",
	// 				lastName: "González Lucas",
	// 				fullName: "Erik Josías González Lucas",
	// 				position: userPosition,
	// 				hospital: userHospitals,
	// 				isAdmin: true,
	// 			};

	// 			dispatch(setLoggedUser(user));

	// 			navigate("/home");
	// 		});
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// };

	const initializeSignIn = (): void => {
		let userPosition: Position = Position.COLAB;
		let userHospitals: string[] = [];

		instance
			.loginPopup()
			.then(async (res) => {
				let idTokenClaims = res.idTokenClaims as any;
				const name = idTokenClaims["name"].split(" ");

				const res_ad_groups = await fetch(
					"https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?$count=true",
					{
						headers: {
							Authorization: "Bearer " + res.accessToken,
						},
					},
				).then((data) => data.json());

				const ad_groups: any[] = [];
				res_ad_groups.value.forEach((group: any) => {
					ad_groups.push(group.displayName);
				});

				// Obtenemos el Tipo de Usuario, los hospitales
				const assignedPositions = ad_groups.filter((group) =>
					POSITIONS_AVAILABLE.some((position: string) =>
						group.includes(position),
					),
				);
				userPosition = assignedPositions[0];

				const assignedHospitals = ad_groups.filter((group) =>
					HOSPITALS_AVAILABLE.some((hospital: string) =>
						group.includes(hospital),
					),
				);

				// Si es superusuario o admin, asignar todas las áreas de todos los hospitales
				if (
					userPosition === Position.SUPERADMIN ||
					userPosition === Position.ADMIN
				) {
					userHospitals = HOSPITALS_AVAILABLE.map(
						(hospital: string) => HOSPITALS_MAP[hospital] || hospital,
					);
				} else {
					// Si no es superusuario o admin, tomar los permisos de los grupos del active directory
					userHospitals = assignedHospitals.map(
						(hospital: string) => HOSPITALS_MAP[hospital] || hospital,
					);
				}

				const user_exists = await usersServices.userExists(
					idTokenClaims["preferred_username"],
				);
				if (user_exists.code !== 200) {
					const hospital = await hospitalsServices.getHospitalInfoPerName(
						userHospitals[0],
					);
					const newUser = {
						first_name: name.length > 2 ? name[0] + " " + name[1] : name[0],
						last_name:
							name.length > 3
								? name[2] + " " + name[3]
								: name[name.length - 1],
						email: idTokenClaims["preferred_username"],
						hospital_unit_id: hospital.id,
						is_active: true,
						is_admin:
							userPosition === Position.ADMIN ||
							userPosition === Position.SUPERADMIN,
					};
					await usersServices.createUser(newUser);
				}

				let res_token = await loginUser(idTokenClaims["preferred_username"]);

				setToken(res_token);
			})
			.then(() => {
				usersServices.getUserLogged().then((res) => {
					const user: ILoggedUser = {
						id: res.id as number,
						initials: res.first_name[0] + res.last_name[0],
						name: res.first_name,
						lastName: res.last_name,
						fullName: res.first_name + " " + res.last_name,
						position: userPosition,
						hospital: userHospitals,
						isAdmin:
							userPosition === Position.ADMIN ||
							userPosition === Position.SUPERADMIN,
					};

					dispatch(setLoggedUser(user));
				});
			});
	};

	async function loginUser(username: string) {
		return usersServices.loginUser(username);
	}

	return (
		<Box className="login">
			<Box className="login__grain" />

			<Stack
				flex={1.4}
				height={"100vh"}
				justifyContent={"space-between"}
			>
				<img
					src={TopLeftIlustration}
					alt=""
					width={"10%"}
					style={{ zIndex: 2, position: "absolute", left: -5, top: -5 }}
				/>

				<img
					src={IllustrationBottomleft}
					alt=""
					width={"25%"}
					style={{
						zIndex: 2,
						position: "absolute",
						left: -5,
						bottom: "-13%",
					}}
				/>

				<Box className="login__header">
					<img
						src={ReachLogo}
						alt="Reach 2030"
					/>

					<Divider
						className="login__header__divider"
						variant="middle"
						flexItem
						orientation="vertical"
					/>

					<Typography>
						La chispa de inspiración y creatividad
						<br />
						para impulsar avances en salud.
					</Typography>
				</Box>

				{/* LOGIN FORM */}
				<Box className="login__body">
					<Typography className="login__body__title">Ideas CHRISTUS</Typography>
					<Typography className="login__body__paragraph">
						Envíanos tus ideas y sé parte de la <br /> Transformación de
						CHRISTUS MUGUERZA.
					</Typography>
					<Typography className="login__body__quote">
						"A veces incluso cambios pequeños <br /> pueden llegar a tener un
						gran impacto..."
					</Typography>
					<Button
						disableRipple
						className="login__body__button"
						onClick={initializeSignIn}
					>
						Entrar
					</Button>
				</Box>

				<Box className="login__footer">
					<Typography>
						Este sitio no es para reportar incidentes que requieran atención
						inmediata. Si necesitas algo urgente, por favor acércate con tu
						jefe directo. <br />— Departamento de Administración Estratégica y
						Transformación
					</Typography>
				</Box>
			</Stack>

			<Box className="login__right">
				<img
					src={BackgroundRight}
					height={"101%"}
					alt=""
					style={{
						zIndex: -1,
						position: "absolute",
						right: -1,
						top: -1,
						justifySelf: "start",
					}}
				/>
			</Box>
		</Box>
	);
}
